"use client";

import { useEffect } from "react";

export default function CrmPwaRegistrar() {
  useEffect(() => {
    if (typeof window !== "undefined" && "serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/sw.js", { scope: "/crm" })
        .then((reg) => {
          console.log("[CRM PWA] Service Worker registered with scope:", reg.scope);
        })
        .catch((err) => {
          console.warn("[CRM PWA] Service Worker registration failed:", err);
        });
    }
  }, []);

  return null;
}
